// extracted by mini-css-extract-plugin
export default {"MenuList":"MenuList_MenuList__-3nTY"};